import {observer} from 'mobx-react';
import {useStoreContext} from '../../../store/store-context';
import {Personal} from './member-profile-component/personal';
import {Security} from './member-profile-component/security';
import NotificationSettings from './member-profile-component/notification';
import {
  Route,
  Routes,
  useLocation,
  useNavigate,
  Navigate,
} from 'react-router-dom';
import {
  FeaturePageContent,
  FeaturePageHeader,
} from '@ui/molecules/feature-page-header';
import {ProfileContent} from './member-profile-style';

export const PROFILE_ROUTES = {
  PERSONAL: '',
  APPS: 'apps',
  NOTIFICATIONS: 'notifications',
  SECURITY: 'security',
};

export const MemberProfilePageElement = observer(() => {
  const {storeDashboardRoutes} = useStoreContext();
  const {activateUserProfileTab} = storeDashboardRoutes;
  const navigate = useNavigate();
  const {pathname} = useLocation();
  const isNotifications = pathname.startsWith('/edit/notifications');
  const isSecurity = pathname.startsWith('/edit/security');
  const isProfile = !isNotifications && !isSecurity;

  const tabs = [
    {
      active: isProfile,
      id: 'profile',
      label: 'Profile',
      onClick: () => {
        activateUserProfileTab('personal');
        navigate('/edit');
      },
    },
    {
      active: isNotifications,
      id: 'notifications',
      label: 'Notifications',
      onClick: () => {
        activateUserProfileTab('notification');
        navigate('/edit/notifications');
      },
    },
    {
      active: isSecurity,
      id: 'security',
      label: 'Security',
      onClick: () => {
        activateUserProfileTab('security');
        navigate('/edit/security');
      },
    },
  ];

  return (
    <>
      <FeaturePageHeader
        tabs={tabs}
        ariaLabel="Profile settings"
        width="focused"
      />
      <FeaturePageContent width="focused">
        <ProfileContent>
          <Routes>
            <Route
              path={`${PROFILE_ROUTES.PERSONAL}/*`}
              element={<Personal />}
            />
            <Route
              path={`${PROFILE_ROUTES.NOTIFICATIONS}/*`}
              element={<NotificationSettings />}
            />
            <Route
              path={`${PROFILE_ROUTES.APPS}/*`}
              element={<Navigate to="/edit" replace />}
            />
            <Route
              path={`${PROFILE_ROUTES.SECURITY}/*`}
              element={<Security />}
            />
          </Routes>
        </ProfileContent>
      </FeaturePageContent>
    </>
  );
});

export const memberprofilePage = () => {
  const Page = observer(() => <MemberProfilePageElement />);
  return {
    Page,
  };
};
